import { loader } from 'graphql.macro'
export default function onlineSchedulePricing ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const onlineSchedulePricingSchema = loader('./onlineSchedulePricing.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(onlineSchedulePricingSchema, {
    haulerId: variables.haulerId
  })
}
